const Game = {
  "label"   : "Games",
  "options" : [
    "Minecraft",
    "League of Legends",
    "Among Us"
  ]
}

export default Game